<template>
  <a-modal
    :title="language['modal.resetPassword']"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    :okText="this.$store.getters.language['common.okButton']"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']"
    style="top:20px;"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item :label="language['user.column.userName']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input :placeholder="language['common.pleaseInput']+language['user.column.userName']" v-decorator="[ 'username', {}]" :readOnly="true"/>
        </a-form-item>

        <a-form-item :label="language['user.column.password']" :labelCol="labelCol" :wrapperCol="wrapperCol" hasFeedback >
          <a-input type="password" :placeholder="language['common.pleaseInput']+language['user.column.password']" v-decorator="[ 'password', validatorRules.password]" />
        </a-form-item>

        <a-form-item :label="language['column.confirmPassword']" :labelCol="labelCol" :wrapperCol="wrapperCol" hasFeedback >
          <a-input type="password" @blur="handleConfirmBlur" :placeholder="language['warning.passwordAgainRequired']" v-decorator="[ 'confirmpassword', validatorRules.confirmpassword]"/>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import {changePassword} from '@/api/api'
  import { getAction,putAction,postAction } from '@/api/manage'

  export default {
    name: "PasswordModal",
    data () {
      return {
        visible: false,
        confirmLoading: false,
        confirmDirty: false,
        disabledPassworld:[],
        disabledPassworldStr:'',
        /*validatorRules:{
          password:{
            rules: [{
              required: true,
              pattern:/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{12,}$/,
              message: this.$store.getters.language['warning.passwordConsists']+'並且密碼不可使用'+this.disabledPassworldStr+'關鍵字'
            }, {
              validator: this.validateToNextPassword,
            }],
          },
          confirmpassword:{
            rules: [{
              required: true, message: this.$store.getters.language['warning.inputpasswordAgain'],
            }, {
              validator: this.compareToFirstPassword,
            }],
          },
        },*/

        model: {},

        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        form:this.$form.createForm(this)
      }
    },
    created () {
      console.log("created");
      getAction("/sys/dictItem/queryPlatformBlackPassword").then(res=> {
        if (res.success) {
          let list = res.result;
          this.disabledPassworld = list
          this.disabledPassworldStr = list.map(item => item.value.trim()).join(', ')
        }
      })
    },
    computed:{
      language() {
        return this.$store.getters.language
      },
      validatorRules(){
        return {
          password:{
            rules: [{
              required: true,
              pattern:/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{12,}$/,
              message: this.$store.getters.language['warning.passwordConsists'].replace("${passwordDisabled}", this.disabledPassworldStr)
            }, {
              validator: this.validateToNextPassword,
            }],
          },
          confirmpassword:{
            rules: [{
              required: true, message: this.$store.getters.language['warning.inputpasswordAgain'],
            }, {
              validator: this.compareToFirstPassword,
            }],
          },
        }
      }
    },
    methods: {
      show (username) {
        this.form.resetFields();
        this.visible = true;
        this.model.username = username;
        this.$nextTick(() => {
          this.form.setFieldsValue({username:username});
        });
      },
      close () {
        this.$emit('close');
        this.visible = false;
        this.disableSubmit = false;
        this.selectedRole = [];
      },
      handleSubmit () {
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            this.confirmLoading = true;
            let formData = Object.assign(this.model, values);
            changePassword(formData).then((res)=>{
              if(res.success){
                this.$message.success(res.message);
                this.$emit('ok');
              }else{
                this.$message.warning(res.message);
              }
            }).finally(() => {
              this.confirmLoading = false;
              this.close();
            });
          }
        })
      },
      handleCancel () {
        this.close()
      },
      validateToNextPassword  (rule, value, callback) {
        const form = this.form;
        const confirmpassword=form.getFieldValue('confirmpassword');
        if (value && confirmpassword && value !== confirmpassword) {
          callback(this.language['warning.passwordEnteredTwiceDifferent']);
        }
        if (value && this.confirmDirty) {
          form.validateFields(['confirm'], { force: true })
        }
        if(!!this.disabledPassworld&&this.disabledPassworld.length>0&&value.match(/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{12,}$/)){
          for(var i=0;i<this.disabledPassworld.length;i++){
            let item = this.disabledPassworld[i];
            if(value.includes(item.value.trim())){
              callback(this.$store.getters.language['warning.passwordConsists'].replace("${passwordDisabled}", this.disabledPassworldStr));
            }
          }
        }
        callback();
      },
      compareToFirstPassword  (rule, value, callback) {
        const form = this.form;
        if (value && value !== form.getFieldValue('password')) {
          callback(this.language['warning.passwordEnteredTwiceDifferent']);
        } else {
          callback()
        }
      },
      handleConfirmBlur  (e) {
        const value = e.target.value
        this.confirmDirty = this.confirmDirty || !!value
      }
    }
  }
</script>